@file:OptIn(InternalResourceApi::class)

package myofficialwebsite_master.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/myofficialwebsite_master.composeapp.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_734_321_064)
internal val Res.drawable.footer_logo: DrawableResource by lazy {
      DrawableResource("drawable:footer_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/footer_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_240_160_447)
internal val Res.drawable.home_banner: DrawableResource by lazy {
      DrawableResource("drawable:home_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_banner.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-517_820_634)
internal val Res.drawable.home_card_focus: DrawableResource by lazy {
      DrawableResource("drawable:home_card_focus", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_card_focus.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(753_483_057)
internal val Res.drawable.home_card_qualification: DrawableResource by lazy {
      DrawableResource("drawable:home_card_qualification", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_card_qualification.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_188_098_062)
internal val Res.drawable.home_card_service: DrawableResource by lazy {
      DrawableResource("drawable:home_card_service", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_card_service.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_734_321_064)
internal val Res.drawable.home_logo: DrawableResource by lazy {
      DrawableResource("drawable:home_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_334_599_469)
internal val Res.drawable.home_partners: DrawableResource by lazy {
      DrawableResource("drawable:home_partners", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_partners.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-650_647_704)
internal val Res.drawable.home_service_ci: DrawableResource by lazy {
      DrawableResource("drawable:home_service_ci", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_service_ci.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_507_150_129)
internal val Res.drawable.home_service_custom: DrawableResource by lazy {
      DrawableResource("drawable:home_service_custom", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_service_custom.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(217_921_938)
internal val Res.drawable.home_service_data: DrawableResource by lazy {
      DrawableResource("drawable:home_service_data", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_service_data.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_377_894_956)
internal val Res.drawable.home_service_fast: DrawableResource by lazy {
      DrawableResource("drawable:home_service_fast", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_service_fast.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-528_599_572)
internal val Res.drawable.home_tab_attendance: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_attendance", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_attendance.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_759_397_318)
internal val Res.drawable.home_tab_bi: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_bi", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_bi.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(833_478_702)
internal val Res.drawable.home_tab_employee: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_employee", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_employee.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(791_177_005)
internal val Res.drawable.home_tab_org: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_org", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_org.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(518_802_108)
internal val Res.drawable.home_tab_performance: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_performance", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_performance.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-818_279_069)
internal val Res.drawable.home_tab_recruit: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_recruit", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_recruit.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_002_124_243)
internal val Res.drawable.home_tab_salary: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_salary", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_salary.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_925_487_235)
internal val Res.drawable.home_tab_shared: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_shared", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_shared.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_253_594_714)
internal val Res.drawable.home_tab_talent: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_talent", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_talent.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_032_728_945)
internal val Res.drawable.home_tab_training: DrawableResource by lazy {
      DrawableResource("drawable:home_tab_training", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_tab_training.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-716_979_270)
internal val Res.drawable.page_banner_about: DrawableResource by lazy {
      DrawableResource("drawable:page_banner_about", setOf(
        ResourceItem(setOf(), "${MD}drawable/page_banner_about.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-848_163_896)
internal val Res.drawable.page_banner_partners: DrawableResource by lazy {
      DrawableResource("drawable:page_banner_partners", setOf(
        ResourceItem(setOf(), "${MD}drawable/page_banner_partners.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-625_583_593)
internal val Res.drawable.page_banner_product_plan: DrawableResource by lazy {
      DrawableResource("drawable:page_banner_product_plan", setOf(
        ResourceItem(setOf(), "${MD}drawable/page_banner_product_plan.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(203_099_602)
internal val Res.drawable.plan_img_47997490: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_47997490", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_47997490.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-647_441_895)
internal val Res.drawable.plan_img_47999078: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_47999078", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_47999078.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_737_481_918)
internal val Res.drawable.plan_img_47999217: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_47999217", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_47999217.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_008_702_445)
internal val Res.drawable.plan_img_47999777: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_47999777", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_47999777.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_101_005_078)
internal val Res.drawable.plan_img_48000113: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_48000113", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_48000113.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_657_079_955)
internal val Res.drawable.plan_img_48000301: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_48000301", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_48000301.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_450_313_406)
internal val Res.drawable.plan_img_48000625: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_48000625", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_48000625.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-281_803_253)
internal val Res.drawable.plan_img_48000653: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_48000653", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_48000653.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_954_634_323)
internal val Res.drawable.plan_img_48000767: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_48000767", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_48000767.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(316_117_839)
internal val Res.drawable.plan_img_48001871: DrawableResource by lazy {
      DrawableResource("drawable:plan_img_48001871", setOf(
        ResourceItem(setOf(), "${MD}drawable/plan_img_48001871.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-664_490_860)
internal val Res.drawable.product_img_47969607: DrawableResource by lazy {
      DrawableResource("drawable:product_img_47969607", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_img_47969607.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_631_068_147)
internal val Res.drawable.product_img_47975940: DrawableResource by lazy {
      DrawableResource("drawable:product_img_47975940", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_img_47975940.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_282_070_083)
internal val Res.drawable.product_img_47976526: DrawableResource by lazy {
      DrawableResource("drawable:product_img_47976526", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_img_47976526.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_996_736_175)
internal val Res.drawable.product_img_47982729: DrawableResource by lazy {
      DrawableResource("drawable:product_img_47982729", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_img_47982729.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_809_046_560)
internal val Res.drawable.product_img_47984753: DrawableResource by lazy {
      DrawableResource("drawable:product_img_47984753", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_img_47984753.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(275_215_919)
internal val Res.drawable.product_img_47984795: DrawableResource by lazy {
      DrawableResource("drawable:product_img_47984795", setOf(
        ResourceItem(setOf(), "${MD}drawable/product_img_47984795.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("footer_logo", Res.drawable.footer_logo)
  map.put("home_banner", Res.drawable.home_banner)
  map.put("home_card_focus", Res.drawable.home_card_focus)
  map.put("home_card_qualification", Res.drawable.home_card_qualification)
  map.put("home_card_service", Res.drawable.home_card_service)
  map.put("home_logo", Res.drawable.home_logo)
  map.put("home_partners", Res.drawable.home_partners)
  map.put("home_service_ci", Res.drawable.home_service_ci)
  map.put("home_service_custom", Res.drawable.home_service_custom)
  map.put("home_service_data", Res.drawable.home_service_data)
  map.put("home_service_fast", Res.drawable.home_service_fast)
  map.put("home_tab_attendance", Res.drawable.home_tab_attendance)
  map.put("home_tab_bi", Res.drawable.home_tab_bi)
  map.put("home_tab_employee", Res.drawable.home_tab_employee)
  map.put("home_tab_org", Res.drawable.home_tab_org)
  map.put("home_tab_performance", Res.drawable.home_tab_performance)
  map.put("home_tab_recruit", Res.drawable.home_tab_recruit)
  map.put("home_tab_salary", Res.drawable.home_tab_salary)
  map.put("home_tab_shared", Res.drawable.home_tab_shared)
  map.put("home_tab_talent", Res.drawable.home_tab_talent)
  map.put("home_tab_training", Res.drawable.home_tab_training)
  map.put("page_banner_about", Res.drawable.page_banner_about)
  map.put("page_banner_partners", Res.drawable.page_banner_partners)
  map.put("page_banner_product_plan", Res.drawable.page_banner_product_plan)
  map.put("plan_img_47997490", Res.drawable.plan_img_47997490)
  map.put("plan_img_47999078", Res.drawable.plan_img_47999078)
  map.put("plan_img_47999217", Res.drawable.plan_img_47999217)
  map.put("plan_img_47999777", Res.drawable.plan_img_47999777)
  map.put("plan_img_48000113", Res.drawable.plan_img_48000113)
  map.put("plan_img_48000301", Res.drawable.plan_img_48000301)
  map.put("plan_img_48000625", Res.drawable.plan_img_48000625)
  map.put("plan_img_48000653", Res.drawable.plan_img_48000653)
  map.put("plan_img_48000767", Res.drawable.plan_img_48000767)
  map.put("plan_img_48001871", Res.drawable.plan_img_48001871)
  map.put("product_img_47969607", Res.drawable.product_img_47969607)
  map.put("product_img_47975940", Res.drawable.product_img_47975940)
  map.put("product_img_47976526", Res.drawable.product_img_47976526)
  map.put("product_img_47982729", Res.drawable.product_img_47982729)
  map.put("product_img_47984753", Res.drawable.product_img_47984753)
  map.put("product_img_47984795", Res.drawable.product_img_47984795)
}
